// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from "react";
import { Link, useLocation, withRouter, RouteComponentProps } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Select from "react-select";
import { Chart } from "react-charts";
import { DateRangePicker, Calendar } from 'react-date-range';
import DatePicker from "react-datepicker";
import { Line } from 'react-chartjs-2';
import { IApplicationState, IAuthenticationState } from "../../../../models/applicationState";
import IUserModelActions, * as userModelActions from "../../../../redux/actions/modalActions";
import HeaderComponent from "../header/header";


// import { NavLink } from "react-router-dom";
// import { FontIcon } from "office-ui-fabric-react";
// import ConditionalNavLink from "../common/conditionalNavLink/conditionalNavLink";
// import { strings } from "../../../common/strings";

/**
 * Side bar that remains visible throughout app experience
 * Contains links to editor, settings, export, etc.
 * @param param0 - {
 *      project - IProject
 * }
 */


export interface IDashBoardProps extends RouteComponentProps, React.Props<DashBoard> {
    userModelActions: IUserModelActions;
    loggedInUser: IAuthenticationState;
}

export interface IDashBoardState {
    modelsList: any;
    selectedModels: any;
}

function mapDispatchToProps(dispatch) {
    return {
        userModelActions: bindActionCreators(userModelActions, dispatch),
    };
}

function mapStateToProps(state: IApplicationState) {
    return {
        loggedInUser: state.loggedInUser,
    };
}

@connect(mapStateToProps, mapDispatchToProps)

export default class DashBoard extends React.Component<IDashBoardProps, IDashBoardState> {
    public state: IDashBoardState = {
        modelsList: [],
        selectedModels: null,
    };

    public async componentDidMount() {
        this.getBlobFiles();
        // const { datasets } = this.refs.chart.chartInstance.data;
        // console.log(datasets[0].data);
    }

    public render() {
        const selectionRange = {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection',
        }
        // const state1 = {
        //     labels: ['1', '2', '3',
        //         '4'],
        //     datasets: [
        //         {
        //             label: "Model",
        //             fill: false,
        //             lineTension: 0.5,
        //             backgroundColor: 'rgba(75,192,192,1)',
        //             borderColor: 'rgba(0,0,0,1)',
        //             borderWidth: 2,
        //             data: [65, 59, 80, 81, 56]
        //         },
        //     ],
        // };

        const data = {
            labels: ['0', 'Sep 4th - 10th', 'Sep 11th - 17th', 'Sep 18th - 24th', 'Sep 25th - 29th'],
            datasets: [
                {
                    label: 'Accuracy Metrics',
                    fill: false,
                    lineTension: 0.1,
                    fontColor: '#ffffff',
                    backgroundColor: 'rgba(75,192,192,0.4)',
                    borderColor: 'rgba(75,192,192,1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: '#ffffff',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 8,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                    pointHoverBorderColor: 'rgba(220,220,220,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: [65, 59, 75, 81, 88, 55, 40, 85]
                }
            ]
        };
        return (
            <>
                <HeaderComponent
                    history={this.props.history}
                    match={this.props.match}
                    location={this.props.location} />
                <div className="container-fluid animated fadeIn">


                    <div className="row mt-3">

                        <div className="col-md-1"> </div>
                        <div className="col-md-3">
                            <label className="mb-0">Select Queue:</label>
                            <Select value={this.state.selectedModels}
                                getOptionLabel={(option) =>
                                    `${option.project_name}`
                                }
                                placeholder="JBS Shipping"
                                className="react-select-container zindex-20"
                                getOptionValue={(option) => `${option.project_name}`}
                                onChange={this.onChange}
                                options={this.state.modelsList}
                                theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary25: "#161a1f",
                                        primary: "#6b727d",
                                        neutral0: "#2a2f35",
                                        neutral20: "#44474c",
                                        neutral30: "#272c33",
                                        neutral50: "#fff",
                                        neutral80: "#9da7b5",
                                    },
                                })}
                            />
                        </div>
                        <div className="col-md-2 date-piker-react">
                            <div className="">
                                <label className="mb-0">Select Period:</label>
                                <div>
                                    {/* <DatePicker selected={new Date()} onChange={this.handleSelect} /> */}
                                    <input type="text" className="form-control date-period" placeholder="Sep 2020" color="white" />
                                </div>

                            </div>

                        </div>

                    </div>


                    <div>

                        <hr className="hr-db" />

                    </div>

                    <div className="row ">

                        <div className="col-lg-1 mb-3  ">

                        </div>

                        <div className="col-lg-2 col-md-4 mb-3 ">

                            <div className="card ">
                                <table className="db-crd captured ">
                                    <tbody>
                                        <tr>
                                            <td className="num"> 524
                                    <span className="symb">
                                                    <i className="fa fa-th bg-color-1" aria-hidden="true"></i>
                                                </span>

                                            </td>

                                        </tr>
                                        <tr>
                                            <td className="hr">
                                                <hr className="hr-captured" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="tit"> Captured </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>

                        </div>


                        <div className="col-lg-2 col-md-4">

                            <div className="card ">
                                <table className="db-crd exported">
                                    <tbody>
                                        <tr>
                                            <td className="num"> 510
                                    <span className="symb">
                                                    <i className="fa fa-upload bg-color-1" aria-hidden="true"></i>
                                                </span>

                                            </td>


                                        </tr>
                                        <tr>
                                            <td className="hr">
                                                <hr className="hr-captured" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="tit"> Processed </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>

                        </div>


                        <div className="col-lg-2 col-md-4">

                            <div className="card ">
                                <table className="db-crd verification">
                                    <tbody>
                                        <tr>
                                            <td className="num"> 500
                                    <span className="symb">

                                                    <i className="fa fa-check-circle bg-color-1" aria-hidden="true"></i>
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="hr">
                                                <hr className="hr-captured" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="tit"> Predicted </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>

                        </div>


                        {/* <div className="col-lg-2 col-md-4">

                        <div className="card ">
                            <table className="db-crd ignored">
                            <tbody>
                                <tr>
                                    <td className="num"> 4
                                    <span className="symb"> <i className="fa fa-ban bg-color-1" aria-hidden="true"></i>
                                    </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="hr">
                                        <hr className="hr-captured" />
                                    </td>
                                </tr>
                                <tr>
                                    <td className="tit"> Ignored </td>
                                </tr>
                                </tbody>
                            </table>

                        </div>

                    </div> */}

                        <div className="col-lg-2 col-md-4">

                            <div className="card ">
                                <table className="db-crd unclassifide">
                                    <tbody>
                                        <tr>
                                            <td className="num"> 10
                                    <span className="symb">
                                                    <i className="fa fa fa-copy bg-color-1" aria-hidden="true"></i>&nbsp;
                 <i className="fa fa-ban fa-small" aria-hidden="true"></i>
                                                </span></td>
                                        </tr>
                                        <tr>
                                            <td className="hr">
                                                <hr className="hr-captured" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="tit"> Unpredicted </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="col-lg-2 col-md-4">
                            <div className="card ">
                                <table className="db-crd failed">
                                    <tbody>
                                        <tr>
                                            <td className="num"> 24
                                    <span className="symb"> <i className="fa fa-times-circle bg-color-1" aria-hidden="true"></i>
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="hr">
                                                <hr className="hr-captured" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="tit"> Failed </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-1 accuracy-lable">
                            <span className="accuracy-rotate">Accuracy % </span>
                        </div>
                        <div className="col-md-10">




                            <div className="card">


                                <div style={{ width: "100%", height: "280px" }}>
                                    <Line ref="chart" data={data}




                                        options={{
                                            tooltips: {
                                                displayColors: false,
                                                backgroundColor: "rgba(255,255,255,0.9)",
                                                enabled: true,
                                                mode: "single",
                                                bodyFontSize: 16,
                                                bodyFontFamily: "arial",
                                                bodyFontColor: "black",
                                                yPadding: 15,
                                                xPadding: 15,
                                                cornerRadius: 4,
                                                bodyFontStyle: "normal",
                                                callbacks: {
                                                    title: () => {
                                                        return "";
                                                    },
                                                    label: (tooltipItems, data) => {
                                                        return tooltipItems.yLabel;
                                                    }
                                                }
                                            },
                                            legend: {
                                                display: true
                                            },
                                            layout: {
                                                padding: {
                                                    left: 0,
                                                    right: 0,
                                                    top: 0,
                                                    bottom: 0
                                                }
                                            },
                                            scales: {
                                                yAxes: [
                                                    {
                                                        gridLines: {
                                                            drawBorder: true,
                                                            color: "rgba(255,255,255,0.05)",
                                                            zeroLineColor: "rgba(255,255,255,0.05)"
                                                        },
                                                        ticks: {
                                                            fontColor: "#ffffff",
                                                            fontFamily: "arial",
                                                            fontSize: 12
                                                        }
                                                    }
                                                ],
                                                xAxes: [
                                                    {
                                                        gridLines: {
                                                            display: true,
                                                            color: "rgba(255,255,255,0.05)",
                                                            zeroLineColor: "rgba(255,255,255,0.05)"
                                                        },
                                                        ticks: {
                                                            fontColor: "#ffffff",
                                                            fontFamily: "arial",
                                                            fontSize: 12
                                                        }
                                                    }
                                                ]
                                            },
                                            maintainAspectRatio: false,
                                            animation: false
                                        }}


                                    />





                                </div>
                            </div>

                            <div className="text-center weekly-lable">
                                Weeks
                        </div>
                        </div>
                        <div className="col-md-1">
                        </div>
                    </div>
                </div>
            </>
        );
    }

    /**
     * Get Blob Files
     */
    private getBlobFiles = () => {
        const userId = this.props.loggedInUser.user.oid;
        this.props.userModelActions.loadUserModels().then((data: any) => {
            this.setState({ modelsList: data, selectedModels: data[0] });
        });
    }

    /**
     * Get Model
     */
    private onChange = (values) => {
        if (values) {
            this.setState({ selectedModels: values });
        }
    }
    /**
     * Get Charts
     */
    private getCharts = () => {
        const series = { showPoints: true }

        return <Chart
            data={[
                {
                    label: "JBS10",
                    data: [[0, 0], [1, 20], [2, 30], [3, 10], [4, 30], [60], [6, 20], [7, 80], [10, 90]]
                },
                {
                    label: "JBS20",
                    data: [[0, 0], [1, 30], [2, 10], [3, 50], [4, 20], [5, 60], [6, 20], [7, 60], [10, 90]]
                },
                {
                    label: "JBS30",
                    data: [[0, 0], [1, 40], [2, 20], [3, 10], [4, 30], [5, 70], [6, 80], [7, 40], [10, 90]]
                }
            ]}
            series={series}
            axes={[
                { primary: true, type: "linear", position: "bottom" },
                { type: "linear", position: "left" }
            ]}
            tooltip dark />;

    }

    /**
     * Dates
     */
    private handleSelect = (ranges) => {
        // console.log(ranges);
        // {
        //   selection: {
        //     startDate: [native Date Object],
        //     endDate: [native Date Object],
        //   }
        // }
    }
}
